/**
 * Chat message object for use in dashboard and widgets.
 * A near copy of cascade's ChatMessage class.
 */
/**
 * Chat message object for using in patronSession.messages
 * @prop {String} sessionId Unique id for client who sent message.
 * @prop {Number} opId Operator user id for operator messages.
 * @prop {String} role Role of client (see cascadeConst).
 * @prop {String} room Name of room message was sent to.
 * @prop {String} ts Timestamp of message in ISO string format.
 * @prop {String} msg Message text.
 * @prop {Number} msgId Unique id in db for message
 * @prop {Boolean} ended Is this message after the chat ended.
 */
class ChatMessage {
    constructor({
        sessionId = '',
        opId = 0,
        role = 'system',
        room = '',
        ts = '',
        msg = '',
        msgId = 0,
        ended = false
    }) {
        this.sessionId = sessionId;
        this.opId = Number(opId);
        this.role = role;
        this.room = room;
        this.ts = ts;
        this.msg = msg;
        this.msgId = Number(msgId);

        if (this.ts === '') {
            this.ts = new Date().toISOString();
        }
        this.ended = ended;
    }
}

export default ChatMessage;
